module.exports = __webpack_public_path__ + "static/media/1_6.4d97062f.png";